export const SLICE_NAME_TARGETS = 'targets'
